export const getEvents = ({ mainEvents: { events } }) => events
